import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { revenueApi } from "@/lib/api";

/**
 * Re-run a failed statement's import. The statement goes back to Processing,
 * and the list and details views poll it out from there (isStatementBusy).
 */
export const useReimportRevenueStatement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => revenueApi.reimportRevenueStatement(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ["revenue-statements"] });
      queryClient.invalidateQueries({ queryKey: ["revenue-statement", id] });
    },
    onError: (error: Error) => {
      toast.error(error?.message ?? "Failed to start the re-import");
    },
  });
};
